const state = {
  filters: [],
}

const getters = {
  filters: (state) => state.filters,
  filtersByType: (state, getters) => {
    return {
      plantsFilters: getters.plantsFilters,
      modeFilters: getters.modeFilters,
      curtainFilters: getters.curtainFilters,
      lightFilters: getters.lightFilters,
      irrigationFilters: getters.irrigationFilters,
      co2Filters: getters.co2Filters,
      ecuFilters: getters.ecuFilters,
      humidifierFilters: getters.humidifierFilters,
      dehumidifierFilters: getters.dehumidifierFilters,
    }
  },
  plantsFilters: (state) => {
    return state.filters.filter(statusFilter => {
      return [
        'hasPlants',
        'noPlants',
      ].indexOf(statusFilter.key) !== -1
    })
  },
  modeFilters: (state) => {
    return state.filters.filter(statusFilter => {
      return [
        'autoMode',
        'manualMode',
      ].indexOf(statusFilter.key) !== -1
    })
  },
  curtainFilters: (state) => {
    return state.filters.filter(statusFilter => {
      return [
        'openCurtains',
        'closedCurtains',
      ].indexOf(statusFilter.key) !== -1
    })
  },
  lightFilters: (state) => {
    return state.filters.filter(statusFilter => {
      return [
        'lightsOn',
        'lightsOff',
      ].indexOf(statusFilter.key) !== -1
    })
  },
  irrigationFilters: (state) => {
    return state.filters.filter(statusFilter => {
      return [
        'irrigating',
        'waitingForLease',
        'notIrrigating',
      ].indexOf(statusFilter.key) !== -1
    })
  },
  co2Filters: (state) => {
    return state.filters.filter(statusFilter => {
      return [
        'co2Disabled',
        'co2EnabledOpen',
        'co2EnabledClosed',
      ].indexOf(statusFilter.key) !== -1
    })
  },
  ecuFilters: (state) => {
    return state.filters.filter(statusFilter => {
      return [
        'cooling',
        'dehumidifying',
        'circulating',
        'ecuOff',
      ].indexOf(statusFilter.key) !== -1
    })
  },
  humidifierFilters: (state) => {
    return state.filters.filter(statusFilter => {
      return [
        'humidifierOn',
        'humidifierOff',
        'noHumidifier',
      ].indexOf(statusFilter.key) !== -1
    })
  },
  dehumidifierFilters: (state) => {
    return state.filters.filter(statusFilter => {
      return [
        'dehumidifierOn',
        'dehumidifierOn1',
        'dehumidifierOff',
        'noDehumidifier',
      ].indexOf(statusFilter.key) !== -1
    })
  }
}

const actions = {
  addFilter({commit}, filter) {
    commit('addFilter', filter)
  },
  removeFilter({commit}, filter) {
    commit('removeFilter', filter)
  }
}

const mutations = {
  addFilter(state, statusFilter) {
    const existingFilter = state.filters.find(eachFilter => eachFilter.key === statusFilter.key)
    if (!existingFilter) {
      state.filters.push(statusFilter)
    }
  },
  removeFilter(state, statusFilterKey) {
    state.filters = state.filters.filter(eachFilter => eachFilter.key !== statusFilterKey)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
